import AppLayout from "../components/layout/AppLayout";
import RakeWorkflowDocuments from "../components/workflow/RakeWorkflowDocuments";

export default function RakeWorkflowDocumentsPage() {
  return (
    <AppLayout hideDateFilter>
      <RakeWorkflowDocuments />
    </AppLayout>
  );
}
